module.exports = __webpack_public_path__ + "img/genres-h5.5388f5b0.webp";